/* Accessible custom selects; native fields remain the source for Shopify forms. */
(() => {
  if (window.ldCollectionSortInitialized) return;
  window.ldCollectionSortInitialized = true;
  function enhance(select) {
    if (select.dataset.customSort) return;
    select.dataset.customSort = 'true';
    const wrapper = document.createElement('div');
    wrapper.className = 'ld-sort';
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'ld-sort__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    const label = document.querySelector(`label[for="${select.id}"]`);
    const panel = document.createElement('div');
    panel.className = 'ld-sort__options';
    panel.hidden = true;
    const menu = document.createElement('div');
    menu.id = `${select.id}-options`;
    menu.setAttribute('role', 'listbox');
    menu.setAttribute('aria-label', label?.textContent.trim() || 'Sort');
    trigger.setAttribute('aria-controls', menu.id);
    let search;
    const options = () => [...menu.querySelectorAll('[role="option"]')].filter(item => !item.hidden && !item.disabled);
    const close = (focus = false) => {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (focus) trigger.focus();
    };
    const sync = () => {
      trigger.textContent = select.selectedOptions[0]?.textContent.trim() || '';
      trigger.setAttribute('aria-label', `${label?.textContent.trim() || ''} ${trigger.textContent}`.trim());
      menu.querySelectorAll('[role="option"]').forEach(item => item.setAttribute('aria-selected', String(item.dataset.value === select.value)));
    };
    const empty = document.createElement('p');
    empty.className = 'ld-select-empty';
    empty.textContent = select.dataset.emptyLabel || '';
    empty.setAttribute('role', 'status');
    empty.hidden = true;
    if (select.dataset.searchable) {
      search = document.createElement('input');
      search.type = 'search';
      search.className = 'ld-select-search';
      search.placeholder = select.dataset.searchLabel;
      search.setAttribute('aria-label', `${select.dataset.searchLabel} ${label?.textContent.trim() || ''}`);
      search.setAttribute('aria-controls', menu.id);
      search.addEventListener('input', event => {
        event.stopPropagation(); // Search within options must not submit product filters.
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const term = normalize(search.value.trim());
        menu.querySelectorAll('[role="option"]').forEach(item => item.hidden = item.dataset.value !== '' && !normalize(item.textContent).includes(term));
        empty.hidden = [...menu.children].some(item => item.dataset.value && !item.hidden);
      });
      panel.append(search);
    }
    const open = () => {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      if (search) { search.value = ''; search.dispatchEvent(new Event('input')); search.focus(); }
      else (menu.querySelector('[aria-selected="true"]') || options()[0])?.focus();
    };
    [...select.options].forEach(option => {
      const item = document.createElement('button');
      item.type = 'button'; item.tabIndex = -1;
      item.setAttribute('role', 'option');
      item.dataset.value = option.value;
      item.textContent = option.textContent.trim();
      item.disabled = option.disabled;
      item.addEventListener('click', () => {
        select.value = option.value; sync(); close(true);
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      menu.append(item);
    });
    panel.append(menu, empty);
    trigger.addEventListener('click', () => panel.hidden ? open() : close());
    wrapper.addEventListener('keydown', event => {
      const items = options(); const index = items.indexOf(document.activeElement);
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(true); }
      else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key) && !(event.target === search && ['Home', 'End'].includes(event.key))) {
        event.preventDefault();
        if (panel.hidden) { open(); return; }
        if (!items.length) return;
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items[next].focus();
      }
    });
    wrapper.addEventListener('focusout', event => { if (!wrapper.contains(event.relatedTarget)) close(); });
    select.before(wrapper); wrapper.append(trigger, panel, select); select.hidden = true;
    select.addEventListener('change', sync);
    if (label) label.addEventListener('click', event => { event.preventDefault(); trigger.focus(); });
    sync();
  }
  const initialize = () => document.querySelectorAll('.ld-collection-catalog select:is([name="sort_by"], .ld-filter-select):not([data-custom-sort])').forEach(enhance);
  document.addEventListener('pointerdown', event => document.querySelectorAll('.ld-sort').forEach(wrapper => {
    if (!wrapper.contains(event.target)) {
      wrapper.querySelector('.ld-sort__options').hidden = true;
      wrapper.querySelector('.ld-sort__trigger').setAttribute('aria-expanded', 'false');
    }
  }));
  initialize();
  new MutationObserver(initialize).observe(document.querySelector('#MainContent'), { childList: true, subtree: true });
})();
